import * as React from "react";

const IconCartRemoveHover: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="7">
            <path
                fill="currentColor"
                d="m3.693 6.863 5.175-5.398a.484.484 0 0 0 0-.664L8.232.137a.437.437 0 0 0-.637 0L3.375 4.54l-1.97-2.055a.437.437 0 0 0-.637 0l-.636.664a.484.484 0 0 0 0 .664l2.925 3.05c.176.184.46.184.636 0Z"
            />
        </svg>
    );
};

export default React.memo(IconCartRemoveHover);
